import { Tabs } from "expo-router";
import { useColorScheme } from "nativewind";
import { useTranslation } from "react-i18next";
import { Platform } from "react-native";

import { Icon } from "@/components/ui/icon";
import { NAV_THEME } from "@/lib/theme";
import { TEST_IDS } from "@/testIdDefinition";
import { FontAwesome6ProRegularIconName } from "@react-native-vector-icons/fontawesome6-pro";

type TabIconProps = {
    name: FontAwesome6ProRegularIconName;
    color: string;
    focused: boolean;
};

function TabIcon({ name, color, focused }: TabIconProps) {
    return (
        <Icon
            name={name}
            iconStyle={focused ? "solid" : "regular"}
            size={20}
            color={color}
        />
    );
}

export default function TabsLayout() {
    const { t } = useTranslation();
    const { colorScheme } = useColorScheme();
    const scheme = colorScheme ?? "light";
    const colors = NAV_THEME[scheme].colors;

    return (
        <Tabs
            screenOptions={{
                headerShown: false,
                tabBarHideOnKeyboard: true,
                tabBarActiveTintColor: colors.primary,
                tabBarInactiveTintColor: colors.text,
                tabBarStyle: {
                    backgroundColor: colors.background,
                    borderTopColor: colors.border,
                    ...(Platform.OS === "ios" ? { paddingTop: 4 } : null),
                },
                tabBarLabelStyle: {
                    fontFamily: "Inter_500Medium",
                    fontSize: 12,
                },
            }}
        >
            <Tabs.Screen
                name="index"
                options={{
                    title: t("nav.home"),
                    tabBarButtonTestID: TEST_IDS[TEST_IDS.HOME_LINK],
                    tabBarIcon: ({ color, focused }) => (
                        <TabIcon
                            name="house"
                            color={String(color)}
                            focused={focused}
                        />
                    ),
                }}
            />
            <Tabs.Screen
                name="submissions"
                options={{
                    title: t("nav.requests"),
                    tabBarButtonTestID: TEST_IDS[TEST_IDS.REQUESTS_LINK],
                    tabBarIcon: ({ color, focused }) => (
                        <TabIcon
                            name="clipboard-list"
                            color={String(color)}
                            focused={focused}
                        />
                    ),
                }}
            />
            <Tabs.Screen
                name="family"
                options={{
                    title: t("nav.family"),
                    tabBarButtonTestID: TEST_IDS[TEST_IDS.ACCOUNT_LINK],
                    tabBarIcon: ({ color, focused }) => (
                        <TabIcon
                            name="user-group-simple"
                            color={String(color)}
                            focused={focused}
                        />
                    ),
                }}
            />
            <Tabs.Screen
                name="menu"
                options={{
                    title: t("nav.menu"),
                    tabBarButtonTestID: TEST_IDS[TEST_IDS.MENU_LINK],
                    tabBarIcon: ({ color, focused }) => (
                        <TabIcon
                            name="bars"
                            color={String(color)}
                            focused={focused}
                        />
                    ),
                }}
            />
        </Tabs>
    );
}
